import React from 'react'
import { icons } from 'app/constants'
import { useIntl } from 'hooks'
import { Button } from 'components/Zui'
import './index.css'

function Index({ handleDownload, isDownloadable, error }) {
    let message
    const { t } = useIntl()
    const ICON = icons['download']

    if (error) {
        message = error
    } else if (isDownloadable) {
        message = t('fallback.video.player.text')
    } else if (!isDownloadable) {
        message = t('fallback.video.player.nodownload')
    }

    return (
        <div className="video-player-fallback-wrapper">
            <div className="video-player-fallback-content">
                <div className="video-player-fallback-msg">
                    <span>{message}</span>
                </div>
                {!error && (
                    <div className="download-video-btn">
                        <Button
                            environment="auto"
                            emphasis="highlight"
                            onClick={handleDownload}
                            disabled={!isDownloadable}
                        >
                            {t('download.video')}
                            <ICON slot="icon" style={{ paddingRight: '9px' }} />
                        </Button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Index
